import { TaskType } from '@/lib/sdk/chatbot/types';

export const ALL_TYPE_OPTIONS: { value: TaskType; label: string }[] = [
  { value: TaskType.INTRO, label: 'Intro' },
  { value: TaskType.TEXT, label: 'Text' },
  { value: TaskType.NUMBER, label: 'Number' },
  { value: TaskType.PHOTO, label: 'Photo' },
  { value: TaskType.DOCUMENT, label: 'Document' },
  { value: TaskType.DATE, label: 'Date' },
  { value: TaskType.LOCATION, label: 'Location' },
  { value: TaskType.LOCATION_CHECK, label: 'Location Check' },
  { value: TaskType.ADDRESS, label: 'Address' },
  { value: TaskType.CHOICE, label: 'Choice' },
  { value: TaskType.DYNAMIC_CHOICE, label: 'Dynamic Choice' },
  { value: TaskType.REGULAR, label: 'Regular' },
  { value: TaskType.END, label: 'End' },
  { value: TaskType.VIDEO, label: 'Video' },
  { value: TaskType.MEDIA, label: 'Media' },
  { value: TaskType.TASKLIST, label: 'Task List' },
  { value: TaskType.ROLE, label: 'Role Check' },
  { value: TaskType.COUNTER, label: 'Counter' },
];

export const SOP_TYPE_OPTIONS: { value: TaskType; label: string }[] = [
  { value: TaskType.REGULAR, label: 'Regular' },
];

export const DATA_PLACEHOLDER: Partial<Record<TaskType, string>> = {
  [TaskType.LOCATION]: '— configure via panel →',
  [TaskType.LOCATION_CHECK]: '— configure via panel →',
  [TaskType.DYNAMIC_CHOICE]: '— configure via panel →',
  [TaskType.CHOICE]: 'Option 1,Option 2,Option 3',
  [TaskType.INTRO]: 'Image URL (optional)',
  [TaskType.TEXT]: 'Additional info',
  [TaskType.ADDRESS]: 'Additional info (optional)',
  [TaskType.TASKLIST]: '— configure via panel →',
  [TaskType.ROLE]: '— configure via panel →',
  [TaskType.COUNTER]: '— configure via panel →',
};

export const PANEL_ONLY_TYPES = new Set([
  TaskType.LOCATION,
  TaskType.LOCATION_CHECK,
  TaskType.DYNAMIC_CHOICE,
  TaskType.TASKLIST,
  TaskType.ROLE,
  TaskType.COUNTER,
]);
